import { render } from "./Investment.vue?vue&type=template&id=3dbad280&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"

import "./Investment.vue?vue&type=style&index=0&id=3dbad280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbad280"]])

export default __exports__